// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"ellipsis-dee1bee7","lines":"lines-dee06a12","shadow":"shadow-948ab412","lineClamp":"lineClamp-436524c8"};